/* eslint-disable class-methods-use-this */

import { Controller } from 'stimulus';
import jump from 'jump.js';
import toArray from '../helpers/toArray';
import universalTracking from '../tracking/universalTracking';
import getControllerForElement from '../helpers/getControllerForElement';
import validateAndSetDeliveryYears from '../helpers/validateAndSetDeliveryYear';

class PreorderFormController extends Controller {
  connect() {
    const checkedProduct = document.querySelector('.js-product-checkbox:checked');

    if (checkedProduct) {
      this.onProductToggle({ currentTarget: checkedProduct });
    }

    this.onFlatpackDeliveryChange();
    this.validateAndSetDeliveryYears();
  }

  onNextStepClick(event) {
    const toStep = parseInt(event.currentTarget.getAttribute('data-to-step'), 10);
    const currentStepElement = event.currentTarget.closest('[data-step]');

    const validateMethod = currentStepElement.getAttribute('data-validate-method');

    if (validateMethod) {
      const validatorMethod = this[validateMethod];

      if (!validatorMethod(currentStepElement)) {
        return;
      }
    }

    universalTracking.event('Pre-order', 'completed step', toStep - 1);

    let jumpToElement = null;

    this.stepTargets.forEach((stepElement) => {
      const step = parseInt(stepElement.getAttribute('data-step'), 10);

      if (step <= toStep) {
        stepElement.removeAttribute('hidden');
        jumpToElement = stepElement;

        this.refreshComponents(stepElement);
      }
    });

    this.validateAndSetDeliveryYears();

    if (jumpToElement) {
      jump(jumpToElement, {
        offset: -50,
      });
    }
  }

  onProductToggle(event) {
    const { checked } = event.currentTarget;
    const productRow = event.currentTarget.closest('[data-target="preorder-form.productRow"]');

    if (!productRow) {
      return;
    }

    const productBody = productRow.querySelector('.js-product-body');

    if (!productBody) {
      return;
    }

    productBody[checked ? 'removeAttribute' : 'setAttribute']('hidden', 'hidden');
  }

  validateStep1(stepElement) {
    const checkedProductCheckboxes = toArray(stepElement.querySelectorAll('.js-product-checkbox:checked'));

    // Retrieve the allowance of flatpack delivery for the selected products
    const flatpackDeliveryEnabled = checkedProductCheckboxes
      .map((checkbox) => {
        return checkbox.getAttribute('data-flatpack-delivery') === 'true';
      })
      .filter((state) => state)
      .length > 0;

    const flatpackDelivery = document.getElementById('flatpack_delivery_wrapper');

    if (flatpackDelivery) {
      flatpackDelivery.style.display = flatpackDeliveryEnabled ? 'block' : 'none';
    }

    return checkedProductCheckboxes.length;
  }

  refreshComponents(element) {
    const controllersToRefresh = ['map-select'];

    controllersToRefresh.forEach((controllerToRefresh) => {
      const elements = toArray(element.querySelectorAll(`[data-controller*='${controllerToRefresh}']`));

      elements.forEach((el) => {
        getControllerForElement(this.application, el, controllerToRefresh)
          .then((controller) => {
            if (controller && typeof controller.refresh === 'function') {
              controller.refresh.call(controller);
            }
          });
      });
    });
  }

  onFlatpackDeliveryChange() {
    const inputField = document.getElementById('flatpack_delivery');
    const informationWrapper = document.getElementById('flatpack_info_wrapper');

    if (!inputField) {
      return;
    }

    informationWrapper.style.display = inputField.value === 'yes' ? 'block' : 'none';
  }

  validateAndSetDeliveryYears() {
    validateAndSetDeliveryYears({
      minimumYear: this.minimumYear(),
      deliverySelect: this.preferredDeliveryTarget,
    });
  }

  minimumYear() {
    const selectedProducts = toArray(this.element.querySelectorAll('.js-product-checkbox:checked'));

    if (!selectedProducts.length) {
      return (new Date()).getFullYear();
    }

    return parseInt(selectedProducts[0].getAttribute('data-minimum-delivery-year'), 10);
  }
}

PreorderFormController.targets = [
  'step',
  'productRow',
  'preferredDelivery',
];

export default PreorderFormController;
